import React from "react";
import ErrorWarning from "../Routes/errorWarning";
import { useStore } from "../Store";

const LoadingPage: React.FC = () => {
  const { loadingStore } = useStore();

  return (
    <div>
      {loadingStore.isLoading && (
        <div className="loading-dots">
          <span className="dot"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      )}
      <ErrorWarning />
    </div>
  );
};

export default LoadingPage;